const getters = {
    getFileState(state){return state.fileState},
    getAssetAnimations(state) {return state.assetsAniamtions}
}

export default getters;


// WEBPACK FOOTER //
// ./src/store/assets/getters.js